<template>
    <t-modal
        :header="product.name"
        v-model="openModal"
        @input="$emit('update:showModal', openModal);"
        :classes="classes">
        <div class="modal-body">
            <variants-picker
                :product.sync="selectedProduct"
                :variants="variants"
            ></variants-picker>

            <size-selector
                :sizes="product.sizes"
                :selectedSize.sync="selectedSize"
            ></size-selector>
            <section class="region region-stock">
                <div class="table-stock-wrapper">
                    <StockModalTable
                        title="Budapesti üzletek"
                        :loading="loading"
                        :items="stockLocations.capital"
                    />

                    <StockModalTable
                        title="Vidéki üzletek"
                        :loading="loading"
                        :items="stockLocations.notCapital"
                    />

                    <StockModalTable
                        title="További üzletek"
                        :loading="loading"
                        :items="stockLocations.other"
                    />
                </div>
            </section>
        </div>
    </t-modal>
</template>

<script>
import SizeSelector from './SizeSelector';
import VariantsPicker from './VariantsPicker';
import StockModalTable from "./StockModalTable";

export default {
    name: 'StockModal',
    components: {VariantsPicker, SizeSelector, StockModalTable},
    props: {
        product: {
            type: Object,
            required: true,
        },

        variants: {
            type: Array,
        },

        size: {
            type: Object,
        },

        showModal: {
            type: Boolean,
        }
    },

    data() {
        return {
            selectedProduct: this.product,
            selectedSize: this.product.size,
            openModal: this.showModal,
            stockLocations: [],
            loading: false,
            classes: {
                overlay: 'overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full fixed z-2000 bg-black bg-opacity-50',
                wrapper: 'relative mx-auto z-50 max-w-4xl px-3 py-12',
                modal: 'bg-white shadow rounded',
                body: 'p-3',
                header: 'border-b border-gray-100 p-3 rounded-t',
                footer: 'bg-gray-100 p-3 rounded-b',
                close: 'bg-gray-100 text-gray-600 rounded-full absolute right-0 top-0 -m-3 h-8 w-8 transition duration-100 ease-in-out hover:bg-gray-200 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
                closeIcon: 'fill-current h-4 w-4',
                overlayEnterClass: 'opacity-0',
                overlayEnterActiveClass: 'transition ease-out duration-100',
                overlayEnterToClass: 'opacity-100',
                overlayLeaveClass: 'opacity-100',
                overlayLeaveActiveClass: 'transition ease-in duration-75',
                overlayLeaveToClass: 'opacity-0',
                enterClass: '',
                enterActiveClass: '',
                enterToClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: '',
            },
        }
    },

    watch: {
        product() {
            this.selectedProduct = this.product
        },

        selectedProduct() {
            this.$emit('update:product', this.selectedProduct);
            this.selectedSize = this.selectedProduct.size
        },

        selectedSize() {
            this.$emit('update:size', this.selectedProduct);
            this.fetchStockLocations()
        },

        showModal() {
            this.openModal = this.showModal
        }
    },

    mounted() {
        this.fetchStockLocations()
    },

    methods: {
        async fetchStockLocations() {
            try {
                this.loading = true
                this.stockLocations = []
                const response = await axios.get('/api/stock-locations/' + this.selectedSize.product_id)
                this.stockLocations = response.data
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        }
    },
}
</script>

<style scoped>

</style>
